module.exports = __webpack_public_path__ + "static/media/lln.63f819fd.jpg";